module.exports = __webpack_public_path__ + "img/file-exchange.afbe7206.svg";